import { FC } from "react";
import { useHistory } from "react-router";
import { PositionType } from "../../organisms/PositionForm/PositionForm";
import { UpdatePosition } from "../../templates/UpdatePosition";

type Props = {
  position: PositionType;
  updatePosition: (position: Partial<PositionType>) => void;
};

const UpdatePositionPage: FC<Props> = ({ position, updatePosition }) => {
  const history = useHistory();

  const onBack = () => {
    return history.goBack();
  };

  const onUpdatePosition = (values: PositionType) => {
    updatePosition(values);
  };

  return (
    <>
      <UpdatePosition
        position={position}
        onBack={onBack}
        onUpdatePosition={onUpdatePosition}
      />
    </>
  );
};

export default UpdatePositionPage;
